import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getGlobalPlaces(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.GLOBAL_PLACES}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getMyPlace() {
    const response = await axiosClient.get(ENDPOINT.MY_PLACE);

    return response.data;
  },

  async getIntranetPlaces(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.INTRANET_PLACES}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getPlaceDetail({ placeId }) {
    const path = ENDPOINT.PLACE_DETAIL(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getPlaceTodayBooking({ placeId }) {
    const path = ENDPOINT.PLACE_TODAY_BOOKINGS(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updatePlace(payload) {
    const { placeId, placeInfo } = payload;
    const path = ENDPOINT.PLACE_DETAIL(placeId);

    const response = await axiosClient.put(path, placeInfo);

    return response.data;
  },

  async updatePlaceStatus(payload) {
    const { placeId, ...data } = payload;
    const path = ENDPOINT.PLACE_STATUS(placeId);

    const response = await axiosClient.put(path, data);

    return response.data;
  },

  async updatePreviewImage({ placeId, image }) {
    const path = ENDPOINT.PLACE_PREVIEW_IMAGE(placeId);

    const response = await axiosClient.put(path, { previewImage: image });

    return response.data;
  },

  async getPlaceImages({ placeId }) {
    const path = ENDPOINT.PLACE_IMAGES(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async postPlaceImages({ images, placeId }) {
    const path = ENDPOINT.PLACE_IMAGES(placeId);

    await axiosClient.post(path, { images });
  },

  async deletePlaceImages({ placeId, images }) {
    const path = ENDPOINT.PLACE_IMAGES(placeId);

    await axiosClient.delete(path, {
      data: { images },
    });
  },

  async changePositionPlaceImages({ placeId, images }) {
    const path = ENDPOINT.PLACE_IMAGES(placeId);

    await axiosClient.put(path, { images });
  },

  async postImagesFromPlaceToRoom({ placeId, images, roomIds }) {
    const path = `${ENDPOINT.ROOM_IMAGES(placeId)}/images`;

    const imagesPost = images.map((item) => item.image);

    await axiosClient.post(path, {
      images: imagesPost,
      roomIds,
    });
  },

  async deleteImagesRoomsFromPlace({ placeId, roomIds, images }) {
    const path = `${ENDPOINT.ROOM_IMAGES(placeId)}/images`;

    const imagesPost = images.map((item) => item.image);

    await axiosClient.delete(path, {
      data: {
        roomIds,
        images: imagesPost,
      },
    });
  },

  async editPlaceServices({ placeId, values }) {
    const path = ENDPOINT.PLACE_SERVICES(placeId);

    await axiosClient.put(path, values);
  },

  async updatePlaceServiceFee({ placeId, value, startAt }) {
    const path = ENDPOINT.PLACE_SERVICE_FEE(placeId);

    const response = await axiosClient.put(path, { value, startAt });

    return response.data;
  },

  async addPlaceOtherFee(payload) {
    const { placeId, ...data } = payload;
    const path = ENDPOINT.PLACE_OTHER_FEES(placeId);

    const response = await axiosClient.post(path, data);

    return response.data;
  },

  async updatePlaceOtherFee(payload) {
    const { placeId, otherFeeId, ...data } = payload;
    const path = ENDPOINT.EDIT_PLACE_OTHER_FEE(placeId, otherFeeId);

    const response = await axiosClient.put(path, data);

    return response.data;
  },

  async deletePlaceOtherFee(payload) {
    const { placeId, otherFeeId } = payload;
    const path = ENDPOINT.EDIT_PLACE_OTHER_FEE(placeId, otherFeeId);

    const response = await axiosClient.delete(path);

    return response.data;
  },

  async editPlaceParkingService({ placeId, values }) {
    const path = ENDPOINT.PLACE_PARKING_SERVICE(placeId);

    await axiosClient.put(path, values);
  },

  async updateNearbyLandmarks({ placeId, nearbyLandmarks }) {
    const path = ENDPOINT.PLACE_NEARBY_LANDMARKS(placeId);

    const response = await axiosClient.put(path, { nearbyLandmarks });

    return response.data;
  },

  async editCancelPolicy({
    placeId, cancelBookingPolicy,
  }) {
    const path = `${ENDPOINT.PLACE_POLICY(placeId)}/cancel-booking`;

    await axiosClient.put(path, {
      cancelBookingPolicy,
    });
  },

  async editReceiveRoomPolicy({
    placeId, checkInTime, checkOutTime, depositPolicy,
  }) {
    const path = `${ENDPOINT.PLACE_POLICY(placeId)}/check-in`;

    await axiosClient.put(path, {
      checkInTime,
      checkOutTime,
      depositPolicy,
    });
  },

  async editDepositPolicy({
    placeId, paymentMethods,
  }) {
    const path = `${ENDPOINT.PLACE_POLICY(placeId)}/payment`;

    await axiosClient.put(path, {
      paymentMethods,
    });
  },

  async editSmokeAndPetPolicy({
    placeId, allowPet, allowSmoking,
  }) {
    const path = `${ENDPOINT.PLACE_POLICY(placeId)}/pet-and-smoking`;

    await axiosClient.put(path, {
      allowPet,
      allowSmoking,
    });
  },

  async editCurfewPolicy({
    placeId, curfewPolicy,
  }) {
    const path = `${ENDPOINT.PLACE_POLICY(placeId)}/curfew`;

    await axiosClient.put(path, {
      curfewPolicy,
    });
  },

  async editOtherPolicy({
    placeId, id, otherPolicy,
  }) {
    const targetId = placeId || id;
    const path = `${ENDPOINT.PLACE_POLICY(targetId)}/other`;

    await axiosClient.put(path, {
      otherPolicy,
    });
  },

  async getListRoomOfPlace({ placeId }) {
    const path = ENDPOINT.ROOM_IMAGES(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRoomFacilities({ placeId }) {
    const path = ENDPOINT.ROOM_FACILITIES(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateRoomFacilities({
    placeId, data,
  }) {
    const path = ENDPOINT.ROOM_FACILITIES(placeId);

    await axiosClient.put(path, data);
  },

  async createNewPlace(payload) {
    const path = ENDPOINT.CREATE_NEW_PLACE;

    await axiosClient.post(path, payload);
  },

  async updateAvailableRoom(payload) {
    const { placeId, data } = payload;
    const path = ENDPOINT.UPDATE_NUMBER_AVAILABLE_ROOM(placeId);

    await axiosClient.put(path, data);
  },

  async addImageToPublicImages({ placeId, images, video }) {
    const path = ENDPOINT.PLACE_PUBLIC_IMAGES(placeId);
    const payload = {};

    if (images?.length) {
      payload.images = images;
    }

    if (video?.length) {
      payload.video = video;
    }

    const response = await axiosClient.post(path, payload);

    return response.data;
  },

  async updatePlaceVideo({ placeId, video }) {
    const path = ENDPOINT.PLACE_VIDEO(placeId);

    const response = await axiosClient.put(path, { video });

    return response.data;
  },

  async deletePlaceVideo({ placeId }) {
    const path = ENDPOINT.PLACE_VIDEO(placeId);

    const response = await axiosClient.delete(path);

    return response.data;
  },

  async deleteImageFromPublicImages({ placeId, images }) {
    const path = ENDPOINT.PLACE_PUBLIC_IMAGES(placeId);

    await axiosClient.delete(path, {
      data: { images },
    });
  },

  async updateCloseOpenRoom(payload) {
    const { placeId, data } = payload;
    const path = ENDPOINT.UPDATE_CLOSE_OPEN_ROOM(placeId);

    await axiosClient.put(path, data);
  },

  async updatePriceRoom(payload) {
    const { placeId, data } = payload;
    const path = ENDPOINT.UPDATE_PRICE_ROOM(placeId);

    await axiosClient.put(path, data);
  },

  async getPlacePriceTypes({ placeId }) {
    const path = ENDPOINT.PLACE_PRICE_TYPES(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addPlacePriceTypes(payload) {
    const path = ENDPOINT.PLACE_PRICE_TYPES(payload.placeId);

    await axiosClient.post(path, payload);
  },

  async deletePlacePriceTypes({ priceId, placeId }) {
    const path = ENDPOINT.EDIT_PLACE_PRICE_TYPES(priceId, placeId);

    await axiosClient.delete(path);
  },

  async editPlacePriceTypes(payload) {
    const path = ENDPOINT.EDIT_PLACE_PRICE_TYPES(payload.priceId, payload.placeId);

    await axiosClient.put(path, payload);
  },

  async updateChildrenAndExtraBedPolicy(payload) {
    const { placeId, data } = payload;
    const path = ENDPOINT.CHILDREDN_EXTRA_BED(placeId);

    await axiosClient.put(path, data);
  },

  async uploadPlaceContract({ placeId, file }) {
    const path = ENDPOINT.PLACE_CONTRACT(placeId);
    const formData = new FormData();

    formData.append('file', file, file.name);

    const response = await axiosClient.put(path, formData, {
      transformRequest: [(data, headers) => {
        // Let browser set Content-Type with boundary for multipart upload
        // eslint-disable-next-line no-param-reassign
        delete headers['Content-Type'];
        return data;
      }],
    });

    return response.data;
  },

  async deletePlaceFavorite({ placeId }) {
    const path = ENDPOINT.PLACE_FAVORITE(placeId);

    const response = await axiosClient.delete(path);

    return response.data;
  },

  async addPlaceFavorite({ placeId }) {
    const path = ENDPOINT.PLACE_FAVORITE(placeId);

    const response = await axiosClient.put(path);

    return response.data;
  },
};
